import { Box, LoadingIndicator } from '@qga/roo-ui/components';

const ProcessingIndicator = ({ ...props }) => (
  <Box aria-label="Loading" aria-live="assertive" {...props}>
    <LoadingIndicator />
  </Box>
);

ProcessingIndicator.propTypes = {
  ...Box.propTypes,
};

export default ProcessingIndicator;
